import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Phone, Sparkles } from "lucide-react";
import { PHONE_NUMBER, PHONE_TEL } from "../../config/siteConfig";

export const DisclaimerCallout = () => (
  <section className="py-16">
    <div className="mx-auto max-w-4xl px-6">
      <div className="rounded-3xl border border-yellow-500/30 bg-yellow-500/5 p-8 md:p-10">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-yellow-500/20 flex items-center justify-center">
            <AlertTriangle className="w-6 h-6 text-yellow-400" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-yellow-400 mb-4">
              Important Disclaimer
            </h2>
            <div className="space-y-4 text-slate-300 leading-relaxed">
              <p>
                This is a <strong className="text-white">preparation and submission service</strong> that
                navigates the difficulty of social media companies. Every appeal is filed through
                the platform&apos;s own official public channel — by the client on the{" "}
                <strong className="text-white">$99 Case Review</strong>, or by us with the client&apos;s
                written authorization on the <strong className="text-white">$399 Appeal Package</strong>{" "}
                and <strong className="text-white">$499 Priority Support</strong>. No legitimate appeal
                channel exists that is not public.
              </p>
              <div className="bg-slate-800/50 rounded-xl p-4">
                <p className="text-sm font-medium text-white mb-2">Timeline Expectations:</p>
                <ul className="space-y-1 text-sm text-slate-400">
                  <li>• Platforms typically acknowledge submissions within <strong className="text-white">10 days</strong></li>
                  <li>• Final decisions range from <strong className="text-white">14 to 60 days</strong></li>
                </ul>
              </div>
              <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
                <p className="text-red-400 font-medium">
                  Scam Warning: Anyone telling you they <em>guarantee</em> your account will be restored is likely a scam.
                  No legitimate service can guarantee platform decisions.
                </p>
              </div>
              <p>
                Have questions? Run our free Suspension Analyzer or give us a call — we&rsquo;ll honestly tell you whether we can help.
              </p>
            </div>
            <div className="mt-6 flex flex-col sm:flex-row gap-4">
              <Link
                to="/analyze"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-yellow-500 px-6 py-3 text-slate-950 font-semibold hover:bg-yellow-400 transition"
                data-testid="disclaimer-analyze"
              >
                <Sparkles className="w-5 h-5" />
                Analyze My Suspension
              </Link>
              <a
                href={PHONE_TEL}
                className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/20 px-6 py-3 text-white font-medium hover:bg-white/5 transition"
                data-testid="disclaimer-call"
              >
                <Phone className="w-5 h-5" />
                Call: {PHONE_NUMBER}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
